// ============================================
// ملف: src/App.js
// ============================================
import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Features from './components/Features';
// import Clients from './components/Clients';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AnimatedBackground from './components/AnimatedBackground';

function App() {
  const [currentLang, setCurrentLang] = useState('ar');

  useEffect(() => {
    const savedLang = localStorage.getItem('lang');
    if (savedLang) setCurrentLang(savedLang);
  }, []);

  const toggleLang = () => {
    const newLang = currentLang === 'ar' ? 'en' : 'ar';
    setCurrentLang(newLang);
    localStorage.setItem('lang', newLang);
  };

  return (
    <div className="app" dir={currentLang === 'ar' ? 'rtl' : 'ltr'}>
      <AnimatedBackground />
      <Navbar currentLang={currentLang} toggleLang={toggleLang} />
      <Hero currentLang={currentLang} />
      <About currentLang={currentLang} />
      <Services currentLang={currentLang} />
      <Gallery currentLang={currentLang} />
      <Features currentLang={currentLang} />
      {/* <Clients currentLang={currentLang} /> */}
      <FAQ currentLang={currentLang} />
      <Contact currentLang={currentLang} />
      <Footer currentLang={currentLang} />
    </div>
  );
}

export default App;